import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    common: {
      title: 'Fanni Admin',
      search: 'Search',
      add: 'Add',
      actions: 'Actions',
      updatePrice: 'Update Price',
      close: 'Close',
      cancel: 'Cancel',
      remove: 'Remove',
      logout: 'Logout',
      yes: 'Yes',
      no: 'No',
      ban: 'Ban',
      unBan: 'Unban',
      viewBookings: 'View Bookings',
      enabled: 'Enabled',
      disabled: 'Disabled',
      available: 'Available',
      unavailable: 'Unavailable',
      togglePasswordVisibility: 'Toggle password visibility',
      logo: 'Logo',
      logoutConfirmTitle: 'Logout',
      logoutConfirmMessage: 'Are you sure you want to logout?',
      view: 'View',
      na: 'N/A',
      currency: 'OMR',
      tooltip: {
        remove: 'Remove',
        edit: 'Edit',
        delete: 'Delete',
      },
      table: {
        rowsPerPage: 'Rows per page',
        noDataFound: 'No data found',
        sortedAscending: 'sorted ascending',
        sortedDescending: 'sorted descending',
      },
      dialog: {
        delete: {
          title: 'Delete User',
          message: 'Are you sure you want to delete this user permanently?',
          cancelButton: 'Cancel',
          button: 'Delete',
        },
        banUser: {
          title: 'Ban User',
          message: 'Are you sure you want to ban this user?',
          cancelButton: 'Cancel',
          button: 'Ban',
        },
        unbanUser: {
          title: 'Unban User',
          message: 'Are you sure you want to unban this user?',
          cancelButton: 'Cancel',
          button: 'Unban',
        },
        remove: {
          title: 'Remove',
          message: 'Are you sure you want to remove the selected technician?',
          cancelButton: 'Cancel',
          removeButton: 'Remove',
          note: 'Note: Are you sure you want to delete this technician from the list? If confirmed, all assigned services that are still pending or incomplete will be removed from their records.',
        },
        available: {
          title: 'Make Service Available',
          message: 'Are you sure you want to make this service available?',
          cancelButton: 'Cancel',
          button: 'Available',
        },
        unavailable: {
          title: 'Make Service Unavailable',
          message: 'Are you sure you want to make this service unavailable?',
          cancelButton: 'Cancel',
          button: 'Unavailable',
        },
        subServiceAvailable: {
          title: 'Make Subservice Available',
          message: 'Are you sure you want to make this subservice available?',
        },
        subServiceUnavailable: {
          title: 'Make Subservice Unavailable',
          message: 'Are you sure you want to make this subservice unavailable?',
        },
        assignTechnician: {
          title: 'Assign Technician',
          technicianLabel: 'Select Technician',
          priceLabel: 'Price',
          cancelButton: 'Cancel',
          assignButton: 'Assign',
          selectTechnician: 'Select a technician',
          enterPrice: 'Enter price',
        },
        cancelBooking: {
          title: 'Cancel Booking',
          confirmationText: 'Are you sure you want to cancel this booking?',
          reasonLabel: 'Cancellation Reason',
          reasonPlaceholder: 'Enter reason for cancellation (optional)',
          cancel: 'Cancel',
          confirm: 'Confirm',
        },
        editService: {
          title: 'Edit Service',
          serviceLabel: 'Service Title',
          required: 'Service title is required',
          placeholder: 'Enter service title',
          cancel: 'Cancel',
          save: 'Save',
        },
        editSubservice: {
          title: 'Edit Subservice',
          descriptionLabel: 'Description',
          priceLabel: 'Price',
          descriptionRequired: 'Description is required',
          descriptionPlaceholder: 'Enter subservice description',
          priceRequired: 'Price is required',
          pricePlaceholder: 'Enter price',
          pricePositive: 'Price must be a positive number',
          cancel: 'Cancel',
          save: 'Save',
        },
        clearChat: {
          title: 'Clear Chat',
          message: 'Are you sure you want to clear all messages in this chat?',
          cancel: 'Cancel',
          clear: 'Clear',
        },
      },
    },
    sidebar: {
      users: 'Users',
      technicians: 'Technicians',
      services: 'Services',
      bookings: 'Bookings',
      bookingDetails: 'Booking Details',
      chat: 'Chat',
      support: 'General inquiries',
      changePassword: 'Change Password',
    },
    users: {
      name: 'Name',
      phone: 'Phone',
      createdOn: 'Created On',
    },
    services: {
      serviceName: 'Service Name',
      image: 'Image',
      status: 'Status',
      acService: 'AC Service',
      createdOn: 'Created On',
      available: 'Available',
      unavailable: 'Unavailable',
      subservices: 'Subservices',
      searchSubservices: 'Search subservices',
      noSubservicesFound: 'No subservices found',
    },
    subservices: {
      title: 'Subservices',
      image: 'Image',
      subServiceName: 'Sub Service Name',
      description: 'Description',
      price: 'Price',
      seeMore: 'See More',
      seeLess: 'See Less',
      backToServices: 'Back to Services',
    },
    technicians: {
      addNew: 'Add Technician',
      addNewTitle: 'Add New Technician',
      name: 'Name',
      fullName: 'Full Name',
      fullNamePlaceholder: 'Enter full name',
      phone: 'Phone',
      profilePic: 'Profile Pic',
      role: 'Role',
      language: 'Language',
      notifications: 'Notifications',
      firstTimeUser: 'First Time User',
      verifiedOn: 'Verified On',
      createdOn: 'Created On',
      validation: {
        phoneRequired: 'Phone is required',
        phoneFormat: 'Phone number must start with 9 or 7',
        phoneLength: 'Phone number must be exactly 8 digits',
        fullNameInvalid: 'Only letters and spaces are allowed.',
        fullNameEmptySpace: 'Please enter a valid name',
        fullNameRequired: 'Full name is required',
        fullNameLength: 'Name must be at least 2 characters',
        profilePicRequired: 'Profile picture is required',
      },
      messages: {
        addSuccess: 'Technician added successfully',
        addError: 'Error adding technician',
        invalidFileType: 'Invalid file type. Only image files allowed.',
        fileSizeLimit: 'Image should be less than 5 MB',
      },
    },
    bookings: {
      title: 'Bookings',
      orderNumber: 'Order Number',
      customerName: 'Customer Name',
      customerAddress: 'Customer Address',
      service: 'Service',
      subService: 'Sub Service',
      date: 'Date',
      time: 'Time',
      // startDate: 'Start Date',
      // endDate: 'End Date',
      technician: 'Technician',
      price: 'Price',
      assignTechnician: 'Assign Technician',
      viewOnMap: 'View On Map',
      openInMap: 'Open in Map',
      cancelBooking: 'Cancel Booking',
      backToBookings: 'Back to Bookings',
      chat: 'Chat',
      status: {
        upcoming: 'Upcoming Bookings',
        inProgress: 'In Progress',
        history: 'Booking History',
      },
      rowStatus: {
        label: 'Status',
        upcoming: 'Upcoming',
        inProgress: 'In Progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
        history: 'History',
      },
    },
    chat: {
      type: {
        recent: 'Recent',
        completed: 'Completed',
      },
      messages: {
        typeHereMessage: 'Type here message',
        noChatsFound: 'No chats found',
        noMessagesYet: 'No messages yet',
        backToChatList: 'Back to chat list',
        clearChat: 'Clear Chat',
        noMessagesStartConversation: 'No messages yet. Start the conversation!',
        selectChatToViewDetails: 'Select a chat to view details',
        serviceCompleted: 'This service has been completed',
        serviceCancelled: 'This service has been cancelled',
        sentImage: 'Sent an image',
      },
      validation: {
        messageRequired: 'Message cannot be empty',
        messageFormat: 'Invalid message format',
      },
    },
    auth: {
      emailAddress: 'Email address',
      password: 'Password',
      signIn: 'Log In',
      enterEmail: 'Enter email address',
      enterPassword: 'Enter password',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      enterOldPassword: 'Enter old password',
      enterNewPassword: 'Enter new password',
      enterConfirmPassword: 'Enter confirm password',
      changePassword: 'Change Password',
    },
    validation: {
      enterEmail: 'Enter your email',
      invalidEmail: 'Enter a valid email',
      emailRequired: 'Email is required',
      enterPassword: 'Enter your password',
      passwordRequired: 'Password is required',
      passwordLength: 'Please enter a valid password',
      oldPasswordRequired: 'Old password is required',
      newPasswordRequired: 'New password is required',
      confirmPasswordRequired: 'Confirm password is required',
      passwordsMustMatch: 'Confirm password must be same as password',
      technicianRequired: 'Technician is required',
      pricePositive: 'Must be a positive number',
      priceMin: 'Must be at least {{value}}',
      priceRequired: 'Price is required',
    },
  },
  ar: {
    common: {
      title: 'فني أدمين',
      search: 'بحث',
      add: 'إضافة',
      actions: 'إجراءات',
      close: 'إغلاق',
      updatePrice: 'تحديث السعر',
      cancel: 'إلغاء',
      remove: 'حذف',
      logout: 'تسجيل خروج',
      yes: 'نعم',
      no: 'لا',
      ban: 'حظر',
      unBan: 'إلغاء الحظر',
      viewBookings: 'عرض الحجوزات',
      enabled: 'مفعّل',
      disabled: 'معطّل',
      available: 'متوفر',
      unavailable: 'غير متوفر',
      togglePasswordVisibility: 'إظهار/إخفاء كلمة المرور',
      logo: 'الشعار',
      logoutConfirmTitle: 'تسجيل الخروج',
      logoutConfirmMessage: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
      view: 'عرض',
      na: 'غير متوفر',
      currency: 'ر.ع',
      tooltip: {
        remove: 'حذف',
        edit: 'تعديل',
        delete: 'حذف',
      },
      table: {
        rowsPerPage: 'عدد الصفوف في الصفحة',
        noDataFound: 'لم يتم العثور على بيانات',
        sortedAscending: 'ترتيب تصاعدي',
        sortedDescending: 'ترتيب تنازلي',
      },
      dialog: {
        delete: {
          title: 'حذف المستخدم',
          message: 'هل أنت متأكد أنك تريد حذف هذا المستخدم نهائيًا؟',
          cancelButton: 'إلغاء',
          button: 'حذف',
        },
        banUser: {
          title: 'حظر المستخدم',
          message: 'هل أنت متأكد أنك تريد حظر هذا المستخدم؟',
          cancelButton: 'إلغاء',
          button: 'حظر',
        },
        unbanUser: {
          title: 'إلغاء حظر المستخدم',
          message: 'هل أنت متأكد أنك تريد إلغاء حظر هذا المستخدم؟',
          cancelButton: 'إلغاء',
          button: 'إلغاء الحظر',
        },
        remove: {
          title: 'حذف',
          message: 'هل أنت متأكد أنك تريد حذف الفني المحدد؟',
          cancelButton: 'إلغاء',
          removeButton: 'حذف',
          note: 'ملاحظة: هل أنت متأكد أنك تريد حذف هذا الفني من القائمة؟ إذا تم التأكيد، سيتم حذف جميع الخدمات المعينة التي لا تزال معلقة أو غير مكتملة من سجلاتهم.',
        },
        available: {
          title: 'جعل الخدمة متوفرة',
          message: 'هل أنت متأكد أنك تريد جعل هذه الخدمة متوفرة؟',
          cancelButton: 'إلغاء',
          button: 'متوفر',
        },
        unavailable: {
          title: 'جعل الخدمة غير متوفرة',
          message: 'هل أنت متأكد أنك تريد جعل هذه الخدمة غير متوفرة؟',
          cancelButton: 'إلغاء',
          button: 'غير متوفر',
        },
        subServiceAvailable: {
          title: 'جعل الخدمة الفرعية متاحة',
          message: 'هل أنت متأكد أنك تريد جعل هذه الخدمة الفرعية متاحة؟',
        },
        subServiceUnavailable: {
          title: 'جعل الخدمة الفرعية غير متاحة',
          message: 'هل أنت متأكد أنك تريد جعل هذه الخدمة الفرعية غير متاحة؟',
        },
        assignTechnician: {
          title: 'تعيين فني',
          technicianLabel: 'اختر الفني',
          priceLabel: 'السعر',
          cancelButton: 'إلغاء',
          assignButton: 'تعيين',
          selectTechnician: 'اختر فني',
          enterPrice: 'أدخل السعر',
          technicianRequired: 'الفني مطلوب',
          pricePositive: 'يجب أن يكون رقماً موجباً',
          priceMin: 'يجب أن يكون على الأقل {{value}}',
          priceRequired: 'السعر مطلوب',
        },
        cancelBooking: {
          title: 'إلغاء الحجز',
          confirmationText: 'هل أنت متأكد من رغبتك في إلغاء هذا الحجز؟',
          reasonLabel: 'سبب الإلغاء',
          reasonPlaceholder: 'أدخل سبب الإلغاء (اختياري)',
          cancel: 'إلغاء',
          confirm: 'تأكيد الإلغاء',
        },
        editService: {
          title: 'تعديل الخدمة',
          serviceLabel: 'عنوان الخدمة',
          required: 'عنوان الخدمة مطلوب',
          placeholder: 'أدخل عنوان الخدمة',
          cancel: 'إلغاء',
          save: 'حفظ',
        },
        editSubservice: {
          title: 'تعديل الخدمة الفرعية',
          descriptionLabel: 'الوصف',
          priceLabel: 'السعر',
          descriptionRequired: 'الوصف مطلوب',
          descriptionPlaceholder: 'أدخل وصف الخدمة الفرعية',
          priceRequired: 'السعر مطلوب',
          pricePlaceholder: 'أدخل السعر',
          pricePositive: 'يجب أن يكون السعر رقماً موجباً',
          cancel: 'إلغاء',
          save: 'حفظ',
        },
        clearChat: {
          title: 'مسح الدردشة',
          message: 'هل أنت متأكد أنك تريد مسح جميع الرسائل في هذه الدردشة؟',
          cancel: 'إلغاء',
          clear: 'مسح',
        },
      },
    },
    sidebar: {
      users: 'المستخدمون',
      technicians: 'الفنيون',
      services: 'الخدمات',
      bookings: 'الحجوزات',
      bookingDetails: 'تفاصيل الحجز',
      chat: 'المحادثات',
      support: 'الاستفسارات العامة',
      changePassword: 'تغيير كلمة المرور',
    },
    users: {
      name: 'الاسم',
      phone: 'الهاتف',
      createdOn: 'تاريخ الإنشاء',
    },
    services: {
      serviceName: 'اسم الخدمة',
      image: 'الصورة',
      status: 'الحالة',
      acService: 'خدمة التكييف',
      createdOn: 'تاريخ الإنشاء',
      available: 'متوفر',
      unavailable: 'غير متوفر',
      subservices: 'الخدمات الفرعية',
      searchSubservices: 'بحث في الخدمات الفرعية',
      noSubservicesFound: 'لم يتم العثور على خدمات فرعية',
    },
    subservices: {
      title: 'الخدمات الفرعية',
      image: 'الصورة',
      subServiceName: 'اسم الخدمة الفرعية',
      description: 'الوصف',
      price: 'السعر',
      seeMore: 'عرض المزيد',
      seeLess: 'عرض أقل',
      backToServices: 'الرجوع إلى الخدمات',
    },
    technicians: {
      addNew: 'إضافة فني',
      addNewTitle: 'إضافة فني جديد',
      name: 'الاسم',
      fullName: 'الاسم الكامل',
      fullNamePlaceholder: 'أدخل الاسم الكامل',
      phone: 'الهاتف',
      profilePic: 'الصورة الشخصية',
      role: 'الدور',
      language: 'اللغة',
      notifications: 'الإشعارات',
      firstTimeUser: 'مستخدم جديد',
      verifiedOn: 'تم التحقق في',
      createdOn: 'تاريخ الإنشاء',
      validation: {
        phoneRequired: 'رقم الهاتف مطلوب',
        phoneFormat: 'يجب أن يبدأ رقم الهاتف بالرقم 9 أو 7',
        phoneLength: 'رقم الهاتف يجب أن يكون مكونًا من 8 أرقام بالضبط',
        fullNameEmptySpace: 'الرجاء إدخال اسم صحيح',
        fullNameInvalid: 'يسمح فقط بالحروف والمسافات.',
        fullNameRequired: 'الاسم الكامل مطلوب',
        fullNameLength: 'يجب أن يكون الاسم على الأقل حرفين',
        profilePicRequired: 'الصورة الشخصية مطلوبة',
      },
      messages: {
        addSuccess: 'تمت إضافة الفني بنجاح',
        addError: 'خطأ في إضافة الفني',
        invalidFileType: 'نوع الملف غير صالح. يُسمح فقط بملفات الصور',
        fileSizeLimit: 'يجب أن يكون حجم الصورة أقل من 5 ميجابايت',
      },
    },
    bookings: {
      title: 'الحجوزات',
      orderNumber: 'رقم الطلب',
      customerName: 'اسم العميل',
      customerAddress: 'عنوان العميل',
      service: 'الخدمة',
      subService: 'الخدمة الفرعية',
      date: 'التاريخ',
      time: 'الوقت',
      // startDate: 'تاريخ البدء',
      // endDate: 'تاريخ الإنتهاء',
      technician: 'الفني',
      price: 'السعر',
      assignTechnician: 'تعيين فني',
      chat: 'دردشة',
      cancelBooking: 'إلغاء الحجز',
      backToBookings: 'العودة إلى الحجوزات',
      viewOnMap: 'عرض على الخريطة',
      openInMap: 'افتح في الخريطة',
      status: {
        upcoming: 'الحجوزات القادمة',
        inProgress: 'قيد التنفيذ',
        history: 'سجل الحجوزات',
      },
      rowStatus: {
        label: 'الحالة',
        upcoming: 'القادمة',
        inProgress: 'قيد التنفيذ',
        completed: 'مكتمل',
        cancelled: 'ملغى',
        history: 'السجل',
      },
    },
    chat: {
      type: {
        recent: 'الأخيرة',
        completed: 'مكتملة',
      },
      messages: {
        typeHereMessage: 'اكتب الرسالة هنا',
        noChatsFound: 'لا توجد محادثات',
        noMessagesYet: 'لا توجد رسائل بعد',
        backToChatList: 'العودة إلى قائمة المحادثات',
        clearChat: 'مسح الدردشة',
        noMessagesStartConversation: 'لا توجد رسائل بعد. ابدأ المحادثة!',
        selectChatToViewDetails: 'اختر محادثة لعرض التفاصيل',
        serviceCompleted: 'تم إكمال هذه الخدمة',
        serviceCancelled: 'تم إلغاء هذه الخدمة',
        sentImage: 'أرسل صورة',
      },
      validation: {
        messageRequired: 'لا يمكن أن تكون الرسالة فارغة',
        messageFormat: 'تنسيق الرسالة غير صالح',
      },
    },
    auth: {
      emailAddress: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      signIn: 'تسجيل الدخول',
      enterEmail: 'أدخل البريد الإلكتروني',
      enterPassword: 'أدخل كلمة المرور',
      oldPassword: 'كلمة المرور القديمة',
      newPassword: 'كلمة المرور الجديدة',
      confirmPassword: 'تأكيد كلمة المرور',
      enterOldPassword: 'أدخل كلمة المرور القديمة',
      enterNewPassword: 'أدخل كلمة المرور الجديدة',
      enterConfirmPassword: 'أدخل تأكيد كلمة المرور',
      changePassword: 'تغيير كلمة المرور',
    },
    validation: {
      enterEmail: 'أدخل بريدك الإلكتروني',
      invalidEmail: 'أدخل بريدًا إلكترونيًا صالحًا',
      emailRequired: 'البريد الإلكتروني مطلوب',
      enterPassword: 'أدخل كلمة المرور',
      passwordRequired: 'كلمة المرور مطلوبة',
      passwordLength: 'يرجى إدخال كلمة مرور صالحة',
      oldPasswordRequired: 'كلمة المرور القديمة مطلوبة',
      newPasswordRequired: 'كلمة المرور الجديدة مطلوبة',
      confirmPasswordRequired: 'تأكيد كلمة المرور مطلوب',
      passwordsMustMatch: 'يجب أن تتطابق كلمة المرور مع تأكيد كلمة المرور',
      technicianRequired: 'الفني مطلوب',
      pricePositive: 'يجب أن يكون رقمًا إيجابيًا',
      priceMin: 'يجب أن يكون على الأقل {{value}}',
      priceRequired: 'السعر مطلوب',
    },
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language') || 'en',
  fallbackLng: 'en',
  ns: ['common', 'sidebar', 'services', 'auth', 'validation'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
